import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/button/Button';
import './CallToActionFooter.scss';

export default function CallToActionFooter() : JSX.Element {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const onButtonClick = (): void => {
		navigate('/contact');
	};

	return (
		<section className='callToActionFooter'>
			<div className='callToActionFooter__container'>
				<h2 className='callToActionFooter__header'>{t('home.callToActionFooter.header')}</h2>
				<p className='callToActionFooter__text'>{t('home.callToActionFooter.text')}</p>
				<Button className='callToActionFooter__button' onClick={onButtonClick}>{t('home.callToActionFooter.buttonText')}</Button>
			</div>
		</section>
	);
}